import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  borderRadius: '15px'
};

export default function ContactModal({ open, handleClose }) {
  const [name, setName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [isMessageSent, setIsMessageSent] = React.useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = {
      name,
      email,
      message,
    };
    const response = await fetch('https://formspree.io/f/mzbqaalg', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
    });
    try {
      await response.json();
      setIsMessageSent(true);
      // display success message to user
    } catch (error) {
      console.error(error);
      // display error message to user
    }
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <h1 style={{textAlign: 'center', marginBottom: '30px', fontWeight: '800'}}>Contact Us</h1>
          {isMessageSent ? (
            <p style={{ textAlign: 'center' }}>Thank you for your message!</p>
          ) : (
            <form style={{display: 'flex', flexDirection: 'column', padding: '10px'}} onSubmit={handleSubmit}>

              <input type="hidden" name="_subject" value="New contact form submission" />

              <TextField 
                label="Name" 
                variant="outlined" 
                style={{marginBottom: '10px'}}
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
              <TextField 
                label="Email" 
                variant="outlined" 
                style={{marginBottom: '10px'}}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <TextField 
                label="Message" 
                variant="outlined" 
                multiline 
                rows={4} 
                style={{marginBottom: '10px'}}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
              />
              <Button 
                variant="contained" 
                style={{backgroundColor: '#2dbc47',color: 'white', fontWeight: 'bold', borderRadius: '15px', padding: '10px'}}
                type="submit"
              >
                Submit
              </Button>
            </form>
          )}
        </Box>
      </Modal>
    </div>
  );
}
